// components
import CommonActionModal from "../Common/CommonActionModal";
import TaskCreate from "./TaskCreate";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AssignmentIcon from "@mui/icons-material/Assignment";


class TaskCreateModal extends CommonActionModal {
    async setModalOpenFalse() {
        if (this.props.callBack){
            await this.props.callBack();
        }
        this.setState(
            {
                modalOpen: false,
            }
        );
    }

    componentDidMount(){
        this.setState({
            button: {
                icon: AddCircleIcon,
                label: this.props.buttonLabel?this.props.buttonLabel:'Добавить',
                color: this.props.buttonColor?this.props.buttonColor:'primary',
            },
            modalLabel: 'Создание задачи',
            modalIcon: AssignmentIcon,
            mainComponent: TaskCreate,
            mainComponentProps: {
                lockedSteps: this.props.lockedSteps,
                account: this.props.account,
                accountObj: this.props.accountObj,
                opportunity: this.props.opportunity,
                opportunityObj: this.props.opportunityObj,
                phase: this.props.phase,
                phaseObj: this.props.phaseObj,
                activeStep: this.props.activeStep,
                callBack: this.setModalOpenFalse.bind(this),
            },
            ready: true,
        })
    }
}

export default TaskCreateModal
